// =============================================================================
// axios 0.x → 1.x + nock 9.x → 13.x: Environment Validation Helper
// =============================================================================
// In axios 0.x, errors were handled synchronously before Jest cleanup.
// In axios 1.x, error handlers run asynchronously and can execute AFTER
// Jest has torn down JSDOM, when window.document becomes null.
// This helper checks if the environment is still valid before accessing globals.
// IMPACT: Test environment only - in production, window.document is never null.
// =============================================================================
const isEnvironmentValid = () => {
  try {
    return typeof window !== 'undefined' && window.document !== null;
  } catch (e) {
    return false;
  }
};

class WindowUtils {
  static getWindowLocation() {
    // axios 0.x → 1.x + nock 9.x → 13.x: Return mock when JSDOM is torn down
    // IMPACT: Test environment only - prevents "Cannot read properties of null" crashes
    if (!isEnvironmentValid()) {
      return {
        pathname: '',
        search: '',
        origin: '',
        href: '',
        /* istanbul ignore next */
        reload: () => {},
      };
    }
    return window.location;
  }

  static getCurrentPath() {
    return WindowUtils.getWindowLocation().pathname;
  }

  static refresh() {
    WindowUtils.getWindowLocation().reload();
  }

  static getNexoBaseUrl(isRebrandEnabled) {
    if (!isEnvironmentValid()) return '';
    return isRebrandEnabled && window.__new_nexo_base_url__
      ? window.__new_nexo_base_url__
      : window.__nexo_base_url__;
  }

  static getWindowOriginUrl() {
    return WindowUtils.getWindowLocation().origin;
  }

  static getNexoBaseUrlRebrand() {
    if (!isEnvironmentValid()) return '';
    const originUrl = this.getWindowOriginUrl();

    return window.__new_nexo_base_url__ && originUrl.toLowerCase().includes('lyric')
      ? window.__new_nexo_base_url__
      : window.__nexo_base_url__;
  }
}

export default WindowUtils;
